export const uaTranslations = {
  productTitle: "UA Notifications",
  productSubtitle:
    "Daily call-in checks for your state and jurisdiction, with results sent straight to your phone.",
  coverageSnapshotTitle: "Coverage",
  coverageSnapshotDescription:
    "States and jurisdictions we currently support, based on the call-in lines we've verified.",
  sentryIntegrationTitle: "How it works",
  sentryIntegrationDescription:
    "We call the right line for your program every day and send you the result.",
  memberInputsTitle: "What you'll need",
  memberInputsDescription:
    "Most lines need your participant ID. Some programs also require an assigned color code.",
  documentedLabel: "Documented",
  possibleLabel: "Possible",
  demoLabel: "Demo",
  demoCopy: "This is sample data.",
  demoDashboardTitle: "UA Notifications Demo",
  demoDashboardSubtitle: "A preview with sample data — no real calls or services.",
  signupTitle: "UA Notifications",
  signupSubtitle: "Choose your state and provide the details your call-in line requires.",
  whatToHaveReadyTitle: "What you'll need",
  knownUnknownsTitle: "Good to know",
  coverageStatsAriaLabel: "UA Notifications coverage",
} as const;

/** @deprecated Use uaTranslations instead */
export const coUaTranslations = uaTranslations;

export type UaTranslations = typeof uaTranslations;
/** @deprecated Use UaTranslations instead */
export type CoUaTranslations = UaTranslations;
